const _ = require('lodash');
const { monkey } = require('baobab');
const moment = require('moment');
const DATE_FORMAT = 'DD.MM.YYYY';
const { getOrderStateName } = require('../../../helpers/orderStateNameHolder');
const formatter = require('../../../helpers/formatter');
const currentOrderActions = require('../../account/current-order');

const PATHS = {
    showNecessaryDocumentsAddDeleteButtons: ['account', 'orders', 'computed', 'componentsState', 'showNecessaryDocumentsAddDeleteButtons'],
    usersListFilter: ['account', 'orders', 'computed', 'filter'],
    optionsFiltered: ['account', 'orders', 'computed', 'optionsFiltered'],
    isShowSumCanChangeTooltip: ['account', 'orders', 'computed', 'componentsState', 'showSumCanChangeTooltip'],
    isShowOrderParameters: ['account', 'orders', 'computed', 'componentsState', 'isShowOrderParameters'],
    isShowIndividualOrderParameters: ['account', 'orders', 'computed', 'componentsState', 'isShowIndividualOrderParameters'],
    isShowResultUploadButton: ['account', 'orders', 'computed', 'componentsState', 'isShowResultUploadButton'],
    isCanDeleteResult: ['account', 'orders', 'computed', 'componentsState', 'isCanDeleteResult'],
    isDisabledAmountField: ['account', 'orders', 'computed', 'componentsState', 'amount', 'isDisabledAmountField'],
    isLoadingUploadResultDocument: ['account', 'orders', 'currentOrder', 'uploadResultDocument', 'isLoading']
};

const isMatch = (value, filter) => {
    if (filter) {
        return value.toLowerCase().indexOf(filter.toLowerCase()) !== -1;
    }

    return true;
};

module.exports = {
    PATHS,

    computeShowDownloadAllButton (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'showDownloadAllButton'], monkey(
            ['account', 'orders', 'currentOrder', 'exportResult'],
            (exportResult = []) => exportResult && exportResult.length > 1
        ));
    },

    /**
     * Форматируем дату создания
     * @param {Object} state
     */
    computeOrderCreateDate (state) {
        state.set(['account', 'orders', 'computed', 'currentOrder', 'createDate'], monkey(
            ['account', 'orders', 'currentOrder', 'createDate'],
            (createDate = {}) => {
                if (createDate) {
                    return moment(createDate).format(DATE_FORMAT);
                }
                return {};
            }
        ));
    },

    /**
     * Находим название статуса заказа
     * @param {Object} state
     */
    computeOrderStateName (state) {
        state.set(['account', 'orders', 'computed', 'currentOrder', 'stateName'], monkey(
            ['account', 'orders', 'currentOrder', 'stateId'],
            (stateId = -1) => getOrderStateName(stateId)
        ));
    },

    /**
     * Находим название способа оплаты
     * @param {Object} state
     */
    computePaymentTypeName (state) {
        state.set(['account', 'orders', 'computed', 'currentOrder', 'paymentName'], monkey(
            ['account', 'orders', 'currentOrder', 'paymentTypeId'],
            (paymentTypeId = -1) => {
                switch (paymentTypeId) {
                    case 1:
                        return 'Счёт';
                    case 2:
                        return 'Онлайн оплата';
                    default:
                        return '';
                }
            }
        ));
    },

    /**
     * Определяем можно ли редактировать заказ
     * @param {Object} state
     */
    computeOrderIsEditable (state) {
        state.set(['account', 'orders', 'computed', 'currentOrder', 'isEditable'], monkey(
            ['account', 'orders', 'currentOrder', 'stateId'],
            ['account', 'orders', 'currentOrder', 'typeId'],
            (stateId = -1, typeId = -1) => {
                if (typeId === 1 && (stateId === 7 || stateId === 1 || stateId === 1000)) {
                    return true;
                }
                if (typeId === 2 && stateId === 1001) {
                    return true;
                }
                if (typeId === 3 && stateId === 2001) {
                    return true;
                }
                if (typeId === 4 && stateId === 3001) {
                    return true;
                }

                return false;
            }
    ));
    },

    /**
     * Форматируем данные пользователя
     * @param {Object} state
     */
    computeOrderUser (state) {
        state.set(['account', 'orders', 'computed', 'currentOrder', 'user'], monkey(
            ['account', 'orders', 'currentOrder', 'user'],
            (user = {}) => {
                let computedUser = {};
                if (user) {
                    computedUser.fullName = formatter.fullName(user);
                    computedUser.shortName = formatter.shortName(user);
                }
                return computedUser;
            }
        ));
    },

    /**
     * Фильтруем список пользователей
     * @param {Object} state
     */
    filterOptionsUsersList (state) {
        state.set(PATHS.optionsFiltered, monkey(
            ['account', 'orders', 'computed', 'selectedUser', 'options'],
            PATHS.usersListFilter,
            (usersList = [], filter = '') => _.filter(usersList, (item) => isMatch(item.title, filter) || item.isActive)
        ));
    },

    /**
     * Форматируем данные менеджера
     * @param {Object} state
     */
    computeOrderManager (state) {
        state.set(['account', 'orders', 'computed', 'currentOrder', 'manager'], monkey(
            ['account', 'orders', 'currentOrder', 'manager'],
            (manager = {}) => {
                let computedManager = {};
                if (manager) {
                    computedManager.fullName = formatter.fullName(manager);
                }
                return computedManager;
            }
        ));
    },

    /**
     * Вычисляем состояние подсказки "Файл будет загружен менеджером, подождите"
     * @param {Object} state
     */
    computeDocumentsWillBeUploadedTooltipState (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'showDocumentsWillBeUploadedTooltip'], monkey(
            ['account', 'orders', 'currentOrder', 'stateId'],
            ['user', 'role'],
            (stateId = -1, role = '') => {
                if (role === 'client' && (stateId === 2 || stateId === 3 || stateId === 4)) {
                    return true;
                }
                return false;
            }
        ));
    },

    /**
     * Рассчитываем состояниие кнопок добавление/удаления документов
     * @param {Object} state
     */
    computeNecessaryDocumentsAddDeleteButtonsState (state) {
        state.set(PATHS.showNecessaryDocumentsAddDeleteButtons, monkey(
            ['user', 'role'],
            ['account', 'orders', 'currentOrder', 'stateId'],
            (role = '', stateId = -1) => {
                // статусы можно не проверять, они проверяются на сервере,
                // который нам присылает флаги isDeletable и isUploadable
                // но это протестировано и работает, так что пока пусть будет
                // также кнопки доступны для Индивидуальной выборки
                if (role === 'manager' && (stateId !== 7 && stateId !== 1 && stateId !== 6)) {
                    return true;
                }

                return false;
            }
        ));
    },

    /**
     * Рассчитываем состояниие кнопок скачать черновик счета-оферты
     * @param {Object} state
     */
    computeBillDraftDownloadButtonsState (state) {
        state.set(['account', 'orders', 'computed', 'componentsState',
            'showBillDraftDownloadButton'], monkey(
            ['user', 'role'],
            ['account', 'orders', 'currentOrder', 'stateId'],
            (role = '', stateId = -1) => {
                // доступна только менеджеру в статусе "На регистрации"
                if (role === 'manager' && stateId == 2) {
                    return true;
                }
                return false;
            }
        ));
    },

    /**
     * Рассчитываем состояниие кнопоки "Продолжить"
     * @param {Object} state
     */
    computeContinueButtonState (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'showContinueButton'], monkey(
            ['account', 'orders', 'currentOrder', 'isLicenseAgreementAccepted'],
            ['account', 'orders', 'currentOrder', 'stateId'],
            ['account', 'orders', 'currentOrder', 'paymentTypeId'],
            ['user', 'role'],
            ['account', 'orders', 'computed', 'componentsState', 'showSaveAllButton'],
            ['account', 'orders', 'currentOrder', 'typeId'],
            (isLicenseAgreementAccepted = false, stateId = -1, paymentTypeId = -1, role = '',
             showSaveAllButton = false, typeId = -1) => {
                if (typeId === 1) {
                    if (role === 'client') {
                        // "Черновик"
                        if (stateId === 1) {
                            return true;
                        }
                        // пользователь может подтвердить лицензию из любого статуса
                        if (stateId !== 6 && isLicenseAgreementAccepted === false) {
                            return true;
                        }
                    }
                    if (role === 'manager') {
                        if (showSaveAllButton) {
                            return false;
                        }

                        // "Предчерновик", "На регистрации"
                        if (stateId === 7 || stateId === 2) {
                            return true;
                        }
                    }
                }
                if (typeId === 2) {
                    if (stateId === 1001) {
                        return true;
                    }
                }
                if (typeId === 3) {
                    if (stateId === 2001) {
                        return true;
                    }
                }
                if (typeId === 4) {
                    if (role === 'client') {
                        // "Черновик"
                        if (stateId === 3001) {
                            return true;
                        }
                        // пользователь может подтвердить лицензию из любого статуса
                        if (stateId !== 3006 && isLicenseAgreementAccepted === false) {
                            return true;
                        }
                    }
                    if (role === 'manager') {
                        if (showSaveAllButton) {
                            return false;
                        }

                        // "Черновик", "На регистрации"
                        if (stateId === 3001) {
                            return true;
                        }
                    }
                }

                return false;
            }
        ));
    },

    /**
     * Рассчитываем состояниие кнопоки "Оплатить"
     * @param {Object} state
     */
    computePayOnlineButtonState (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'showPayOnlineButton'], monkey(
            ['account', 'orders', 'currentOrder', 'stateId'],
            ['account', 'orders', 'currentOrder', 'paymentForm'],
            (stateId = -1, paymentForm) => !(stateId !== 3 || !paymentForm)
        ));
    },

    /**
     * Рассчитываем что написано на кнопке "Продолжить"
     * @param {Object} state
     */
    computeContinueButtonLabel (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'continueButtonLabel'], monkey(
            ['account', 'orders', 'currentOrder', 'typeId'],
            (typeId = -1) => {
                if (typeId === 2 || typeId === 3) {
                    return 'Выгрузить';
                }

                return 'Продолжить';
            }
        ));
    },

    /**
     * Рассчитываем видимость блока с выборкой
     * @param {Object} state
     */
    computeOrderParametersIsAvailable (state) {
        state.set(PATHS.isShowOrderParameters, monkey(
            ['account', 'orders', 'currentOrder', 'typeId'],
            (typeId = -1) => {
                // Для Индивидуальной выборки нет блока "Стандартная Выборка"
                if (typeId === 4) {
                    return false;
                }

                return true;
            }
        ));
    },

    /**
     * Рассчитываем видимость блока с индивидуальной ценой
     * @param {Object} state
     */
    computeIsShowIndividualOrderParameters (state) {
        state.set(PATHS.isShowIndividualOrderParameters, monkey(
            ['account', 'orders', 'currentOrder', 'typeId'],
            ['user', 'role'],
            (typeId = -1, role) => {
                if (typeId === 4 && role === 'manager') {
                    return true;
                }

                return false;
            }
        ));
    },

    /**
     * Рассчитываем видимость загрузки результата
     * @param {Object} state
     */
    computeIsShowResultUploadButton (state) {
        state.set(PATHS.isShowResultUploadButton, monkey(
            ['account', 'orders', 'currentOrder', 'typeId'],
            ['account', 'orders', 'currentOrder', 'stateId'],
            ['user', 'role'],
            (typeId = -1, stateId = -1, role) => typeId === 4 && stateId === 3001 && role === 'manager'
        ));
    },

    /**
     * Рассчитываем возможность удаления файла результата
     * @param {Object} state
     */
    computeIsCanDeleteResult (state) {
        state.set(PATHS.isCanDeleteResult, monkey(
            ['account', 'orders', 'currentOrder', 'typeId'],
            ['account', 'orders', 'currentOrder', 'stateId'],
            ['user', 'role'],
            (typeId = -1, stateId = -1, role) => {
                if (typeId === 4 && stateId === 3001 && role === 'manager') {
                    return true;
                }

                return false;
            }
        ));
    },

    /**
     * Рассчитываем доступность поля ввода суммы
     * @param {Object} state
     */
    computeIsDisabledAmountField (state) {
        state.set(PATHS.isDisabledAmountField, monkey(
            ['account', 'orders', 'currentOrder', 'typeId'],
            ['account', 'orders', 'currentOrder', 'stateId'],
            ['user', 'role'],
            (typeId = -1, stateId = -1, role) => {
                if (typeId === 4 && stateId === 3001 && role === 'manager') {
                    return false;
                }

                return true;
            }
        ));
    },

    /**
     * Рассчитываем состояниие кнопоки "Оформить заказ"
     * @param {Object} state
     */
    computeMakeOrderButtonState (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'showMakeOrderButton'], monkey(
            ['account', 'orders', 'currentOrder', 'stateId'],
            (stateId = -1) => {
                if (stateId === 1000) {
                    return true;
                }

                return false;
            }
        ));
    },

    /**
     * Рассчитываем состояниие кнопоки "В Архив"
     * @param {Object} state
     */
    computeArchiveButtonState (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'showArchiveButton'], monkey(
            ['account', 'orders', 'currentOrder', 'stateId'],
            ['account', 'orders', 'currentOrder', 'typeId'],
            (stateId = -1, typeId = -1) => {
                if (typeId === 1) {
                    // "Предчерновик" "Черновик", "На регистрации", "Готов к оплате"
                    if (stateId === 7 || stateId === 1 || stateId === 2 || stateId === 3) {
                        return true;
                    }
                }
                if (typeId === 2) {
                    if (stateId !== 1003) {
                        return true;
                    }
                }
                if (typeId === 3) {
                    if (stateId !== 2003) {
                        return true;
                    }
                }
                if (typeId === 4) {
                    // "Черновик", "На регистрации", "Готов к оплате"
                    if (stateId === 3001 || stateId === 3002 || stateId === 3003) {
                        return true;
                    }
                }

                return false;
            }
        ));
    },

    /**
     * Рассчитываем состояниие кнопоки "Сохранить изменения"
     * @param {Object} state
     */
    computeSaveAllButtonState (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'showSaveAllButton'], monkey(
            ['account', 'orders', 'currentOrder', 'stateId'],
            ['user', 'role'],
            ['account', 'orders', 'currentOrder', 'localChanges'],
            ['account', 'orders', 'currentOrder', 'typeId'],
            (stateId, role, localChanges, typeId = -1) => {
                if (localChanges && role && role === 'manager') {
                    if (stateId && stateId !== 6 && typeId !== 4) {
                        return true;
                    }
                }

                return false;
            }
        ));
    },

    /**
     * Рассчитываем состояние кнопки "Повторить"
     * @param {Object} state
     */
    computeRepeatButtonLabel (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'showRepeatButton'], monkey(
            ['account', 'orders', 'currentOrder', 'stateId'],
            (stateId = -1) => {
                // повторить заказ можно в нередактируемых статусах, обычно выгрузка в них уже сделана
                if (stateId === 2 || stateId === 3 || stateId === 4 || stateId === 5 || stateId === 6) {
                    return true;
                }
                if (stateId === 1002 || stateId === 1003) {
                    return true;
                }
                if (stateId === 2002 || stateId === 2003) {
                    return true;
                }

                return false;
            }
        ));
    },

    computeBitrixExportButtonState (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'showBitrixExportButton'], monkey(
            ['account', 'orders', 'currentOrder', 'stateId'],
            ['bitrix', 'isBitrix'],
            ['user', 'isManager'],
            ['account', 'orders', 'currentOrder', 'hasBitrixLeads'],
            (stateId = -1, isBitrix = false, isManager = false, hasBitrixLeads = false) => {
                if (isBitrix === true && isManager === false && (stateId === 4 || stateId === 5) &&
                    hasBitrixLeads === true) {
                    return true;
                }

                return false;
            }
        ));
    },

    computeFreeBitrixExportButtonState (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'showFreeBitrixExportButton'], monkey(
            ['account', 'orders', 'currentOrder', 'stateId'],
            ['user', 'isFreeBitrixExportAllowed'],
            ['bitrix', 'isBitrix'],
            ['user', 'isManager'],
            (stateId = -1, isFreeBitrixExportAllowed = false, isBitrix = false, isManager = false) => {
                if (stateId === 3 && isFreeBitrixExportAllowed === true && isBitrix === true && isManager === false) {
                    return true;
                }

                return false;
            }
        ));
    },

    /**
     * Рассчитываем состояниие чекбокса "Я согласен с лицензионным соглашением"
     * @param {Object} state
     */
    computeLicenseAgreementCheckboxState (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'showLicenseAgreementCheckbox'], monkey(
            ['account', 'orders', 'currentOrder', 'isLicenseAgreementAccepted'],
            ['user', 'role'],
            ['account', 'orders', 'computed', 'componentsState', 'showContinueButton'],
            (isLicenseAgreementAccepted = false, role = '', showContinueButton = false) => {
                // пользователь может подвтерить лицензию из любого статуса
                if (role === 'client' && isLicenseAgreementAccepted === false && showContinueButton) {
                    return true;
                }

                return false;
            }
        ));
    },

    /**
     * Выбираем какую дополнительную информацию нужно показать
     * @param {Object} state
     */
    computeSpecialInfo (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'specialInfo'], monkey(
            ['account', 'orders', 'currentOrder', 'stateId'],
            ['user', 'role'],
            (stateId = -1, role = '') => {
                if (role === 'client' && stateId === 2) {
                    return 'Наши менеджеры прикрепят счет на оплату в ближайшие рабочие сутки.';
                }

                if (role === 'client' && stateId === 3002) {
                    return 'Чтобы продолжить работу с заказом, примите условия оказания услуг ниже.';
                }

                return null;
            }
        ));
    },

    /**
     * Рассчитываем состояние панель действий с кнопками "Продолжить", "В архив"
     * @param {Object} state
     */
    computeActionPanelState (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'showActionPanel'], monkey(
            ['account', 'orders', 'computed', 'componentsState', 'showContinueButton'],
            ['account', 'orders', 'computed', 'componentsState', 'showArchiveButton'],
            ['account', 'orders', 'computed', 'componentsState', 'showSaveAllButton'],
            ['account', 'orders', 'computed', 'componentsState', 'showMakeOrderButton'],
            ['account', 'orders', 'computed', 'componentsState', 'showRepeatButton'],
            ['account', 'orders', 'computed', 'componentsState', 'showPayOnlineButton'],
            (showContinueButton = false, showArchiveButton = false, showSaveAllButton = false,
             showMakeOrderButton = false, showRepeatButton = false, showPayOnlineButton = false) =>
                showContinueButton || showArchiveButton || showSaveAllButton || showMakeOrderButton ||
                showRepeatButton || showPayOnlineButton
        ));
    },

    /**
     * Рассчитываем состояние подсказки "Непосредственно перед заказом сумма может измениться"
     * @param {Object} state
     */
    computeSumCanChangeTooltipState (state) {
        state.set(PATHS.isShowSumCanChangeTooltip, monkey(
            ['account', 'orders', 'currentOrder', 'stateId'],
            (stateId = -1) => {
                // "Черновик", "На регистрации" и не "Индивидуальная выборка"
                if (stateId === 7 || stateId === 1) {
                    return true;
                }

                return false;
            }
        ));
    },

    /**
     * Рассчитываем нужно ли показывать менеджера
     * @param {Object} state
     */
    computeManagerState (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'showManager'], monkey(
            ['user', 'role'],
            ['account', 'orders', 'computed', 'currentOrder', 'manager', 'fullName'],
            (role = '', managerName) => (role === 'user' && managerName) || role === 'manager'
        ));
    },

    /**
     * Рассчитываем нужно ли показывать пользователя
     * @param {Object} state
     */
    computeUserState (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'showUser'], monkey(
            ['user', 'role'],
            ['account', 'orders', 'currentOrder', 'typeId'],
            (role = '', typeId = -1) => {
                if (typeId === 1 || typeId === 4) {
                    return role !== 'unauthorized';
                }

                return false;
            }
        ));
    },

    /**
     * Рассчитываем нужно ли показывать способ оплаты
     * @param {Object} state
     */
    computeShowPaymentType (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'showPaymentType'], monkey(
            ['account', 'orders', 'currentOrder', 'typeId'],
            (typeId = -1) => (typeId === 1)
        ));
    },

    /**
     * Рассчитываем есть ли возможность выбрать менеджера из списка
     * @param {Object} state
     */
    computeManagerSelectState (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'showManagerSelect'], monkey(
            ['account', 'orders', 'currentOrder', 'stateId'],
            ['user', 'role'],
            ['account', 'orders', 'currentOrder', 'typeId'],
            (stateId = -1, role = '', typeId = -1) => {
                if (typeId === 1 && role == 'manager') {
                    // менеджер может поменять менеджера, если заказ ещё не "Выполнен" и не "В архиве"
                    if (stateId != 5 && stateId != 6) {
                        return true;
                    }
                }
                if (typeId === 4 && role == 'manager') {
                    // менеджер может поменять менеджера, если заказ ещё не "Выполнен" и не "В архиве"
                    if (stateId != 3005 && stateId != 3006) {
                        return true;
                    }
                }

                return false;
            }
        ));
    },

    /**
     * Рассчитываем состояниие списка пользователей
     * @param {Object} state
     */
    computeUserSelectState (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'showUserSelect'], monkey(
            ['account', 'orders', 'currentOrder', 'stateId'],
            ['user', 'role'],
            (stateId = -1, role = '') => {
                if (role == 'manager') {
                    // "Предчерновик", "Черновик"
                    if (stateId === 7 || stateId === 1 || stateId === 3001) {
                        return true;
                    }
                }

                return false;
            }
        ));
    },

    /**
     * Рассчитываем состояниие подсказки "Данные заказа изменились"
     * @param {Object} state
     */
    computeDataChangeTooltipState (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'showDataChangeTooltip'], monkey(
            ['account', 'orders', 'currentOrder', 'stateId'],
            ['account', 'orders', 'currentOrder', 'isNeedToConfirmDataChanged'],
            ['account', 'orders', 'currentOrder', 'tooltips', 'hideDataChangedMustBeConfirmed'],
            (stateId = -1, needConfirmDataChanged = false, hideTooltip = false) => {
                // "Черновик", "На регистрации"
                if (stateId === 7 || stateId === 1 || stateId === 2 || stateId === 1001 || stateId === 2001 || stateId === 3001 || stateId === 3002) {
                    if (needConfirmDataChanged && !hideTooltip) {
                        return true;
                    }
                }

                return false;
            }
        ));
    },

    /**
     * Рассчитываем можно ли перевести заказ в следующий статус
     * @param {Object} state
     */
    computeCanMoveOrderToNextState (state) {
        state.set(['account', 'orders', 'computed', 'сanMoveOrderToNextState'], monkey(
            ['account', 'orders', 'currentOrder', 'typeId'],
            currentOrderActions.PATHS.showPriceMustBeBiggerThanZero,
            ['account', 'orders', 'currentOrder', 'tooltips', 'showUserMustBeSelected'],
            ['account', 'orders', 'currentOrder', 'tooltips', 'showLicenseMustBeAccepted'],
            ['account', 'orders', 'currentOrder', 'tooltips', 'showChangesMustBeSavedOrCancelled'],
            currentOrderActions.PATHS.showBillDocumentMustBeAttached,
            currentOrderActions.PATHS.isExportResultMustBeAttached,
            (typeId = -1, showPriceMustBeBiggerThanZero = false, showUserMustBeSelected = false,
             showLicenseMustBeAccepted = false, showChangesMustBeSavedOrCancelled = false,
             showBillDocumentMustBeAttached = false, isExportResultMustBeAttached = false) => {
                // если отображается какая-то из подсказок, что всё плохо, значит заказ дальше двигать нельзя
                if (showPriceMustBeBiggerThanZero || showUserMustBeSelected || showLicenseMustBeAccepted
                    || showChangesMustBeSavedOrCancelled || isExportResultMustBeAttached
                    || (typeId === 4 && showBillDocumentMustBeAttached)) {
                    return false;
                }

                return true;
            }
        ));
    },

    /**
     * Рассчитываем нужно ли показывать блок изменения типа оплаты
     * @param {Object} state
     */
    computePaymentTypeChangePanelState (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'showPaymentTypeChangePanel'], monkey(
            ['account', 'orders', 'currentOrder', 'stateId'],
            (stateId = -1) => (stateId === 1 || stateId === 7 || stateId === 1000 || stateId === 3001)
        ));
    },

    /**
     * Рассчитываем можно ли изменить тип оплаты
     * @param {Object} state
     */
    computeIsOnlinePaymentDisabled (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'onlinePaymentDisabled'], monkey(
            ['account', 'orders', 'currentOrder', 'price', 'total', 'totalPrice'],
            ['account', 'orders', 'computed', 'price', 'data', 'total', 'totalPrice'],
            (totalPrice = -1, computedTotalPrice = -1) => {
                const bigPrice = 250000;
                if (totalPrice > bigPrice || computedTotalPrice > bigPrice) {
                    return true;
                }

                return false;
            }
        ));
    },

    /**
     * Рассчитываем состояние кнопок "Сохранить" и "Отменить" для параметров выгрузки
     * @param {Object} state
     */
    computeIsFilerValuesControlEnabled (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'isFilerValuesControlEnabled'], monkey(
            ['account', 'orders', 'currentOrder', 'filterValuesChanged'],
            ['order', 'price', 'isLoading'],
            (filterValuesChanged, priceIsLoading) => {
                if (filterValuesChanged && !priceIsLoading) {
                    return true;
                }

                return false;
            }
        ));
    },

    /**
     * Вычисляем состояние блока результатов выборки
     * @param {Object} state
     */
    computeExportResultState (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'showExportResult'], monkey(
            ['account', 'orders', 'currentOrder', 'stateId'],
            ['user', 'role'],
            ['account', 'orders', 'currentOrder', 'exportResult'],
            ['account', 'orders', 'currentOrder', 'isLicenseAgreementAccepted'],
            ['account', 'orders', 'currentOrder', 'typeId'],
            (stateId = -1, role = '', exportResult, isLicenseAgreementAccepted = false, typeId = -1) => {
                if (typeId === 1) {
                    // пользователю, который не принял лицензию, ничего не показываем
                    if (role === 'client' && !isLicenseAgreementAccepted) {
                        return false;
                    }
                    if (stateId === 4 || stateId === 5) {
                        return true;
                    }
                    if (role === 'manager' && stateId === 3) {
                        return true;
                    }
                    // в архиве показываем результат выгрузки только, если он есть
                    if (stateId === 6 && exportResult && exportResult.length > 0) {
                        return true;
                    }
                }
                if (typeId === 2 && stateId === 1002) {
                    return true;
                }
                if (typeId === 3 && stateId === 2002) {
                    return true;
                }
                if (typeId === 4) {
                    // пользователю, который не принял лицензию, ничего не показываем
                    if (role === 'client' && !isLicenseAgreementAccepted) {
                        return false;
                    }
                    if (stateId === 3004 || stateId === 3005) {
                        return true;
                    }
                    if (role === 'manager' && (stateId === 3001 || stateId === 3002 || stateId === 3003)) {
                        return true;
                    }
                    // в архиве показываем результат выгрузки только, если он есть
                    if (stateId === 3006 && exportResult && exportResult.length > 0) {
                        return true;
                    }
                }

                return false;
            }
        ));
    },

    /**
     * Выбор менеджера для выбранного заказа
     * @param {Object} state
     */
    setManagerSelect (state) {
        state.set(['account', 'orders', 'computed', 'selectedManager'], monkey(
            ['account', 'orders', 'managers'],
            ['account', 'orders', 'currentOrder', 'manager', 'id'],
            ['account', 'orders', 'currentOrder', 'localChanges', 'selectedManager', 'id'],
            ['account', 'orders', 'ui', 'selectedManager', 'isDisabled'],
            (managers = [], managerId, selectedManagerId, isDisabled) => {
                const selectedId = selectedManagerId || managerId;
                const header = selectedId ? null : 'Выберите менеджера';

                const options = _.map(managers, (manager) => ({
                    isActive: selectedId == manager.id,
                    title: formatOptionTitle(manager),
                    value: manager.id
                }));

                return { options, isDisabled, header };
            }
        ));
    },

    /**
     * Выбор пользователя для выбранного заказа
     * @param {Object} state
     */
    setUserSelect (state) {
        state.set(['account', 'orders', 'computed', 'selectedUser'], monkey(
            ['account', 'orders', 'users'],
            ['account', 'orders', 'currentOrder', 'user', 'id'],
            ['account', 'orders', 'currentOrder', 'localChanges', 'selectedUser', 'id'],
            ['account', 'orders', 'ui', 'selectedUser', 'isDisabled'],
            (users = [], userId, selectedUserId, isDisabled) => {
                let selectedId = selectedUserId || userId;
                let header = null;
                let isUserSelected = true;

                let options = _.map(users, (user) => ({
                    isActive: selectedId == user.id,
                    title: formatOptionTitle(user),
                    value: user.id
                }));

                // если пользователь не выбран
                if (_.every(options, ['isActive', false])) {
                    header = 'Выберите пользователя';
                    isUserSelected = false;
                }

                return { options, isDisabled, header, isUserSelected };
            }
        ));
    },

    setOrderPrice (state) {
        state.set(['account', 'orders', 'computed', 'price'], monkey(
            ['account', 'orders', 'currentOrder', 'filterValuesChanged'],
            ['account', 'orders', 'currentOrder', 'price'],
            ['order', 'price', 'data'],
            ['order', 'price', 'isLoading'],
            (filterValuesChanged, currentOrderPrice, calculatedPrice, isLoadingPrice) => {
                const data = !filterValuesChanged ? currentOrderPrice : calculatedPrice;

                return { data, isLoading: isLoadingPrice };
            }
        ));
    },

    setPaymentType (state) {
        state.set(['account', 'orders', 'computed', 'paymentType'], monkey(
            ['account', 'orders', 'currentOrder', 'paymentTypeId'],
            ['account', 'orders', 'currentOrder', 'localChanges', 'selectedPaymentTypeId'],
            (paymentTypeId, selectedPaymentTypeId) => {
                let selectedId = selectedPaymentTypeId || paymentTypeId;
                const paymentMap = {
                    1: 'invoice',
                    2: 'online'
                };

                let selectType = paymentMap[selectedId];

                let defaultState = {
                    invoice: false,
                    online: false
                };

                defaultState[selectType] = true;

                return defaultState;
            }
        ));
    },

    setUsersListFilter (state) {
        state.set(PATHS.usersListFilter, '');
    },

    createUserButtonIsEnabled (state) {
        state.set(['account', 'orders', 'computed', 'createUserIsEnabled'], monkey(
            ['account', 'orders', 'createUser', 'error'],
            ['account', 'orders', 'createUser', 'input', 'email'],
            (error, email) => _.isEmpty(error) && email && email.length));
    },

    /**
     * Рассчитываем нужно ли запрашивать результаты выгрузки
     * @param {Object} state
     */
    computeIsNeedToGetExportResults (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'getExportResults'], monkey(
            ['account', 'orders', 'currentOrder', 'stateId'],
            ['user', 'role'],
            ['account', 'orders', 'currentOrder', 'exportResult'],
            (stateId = -1, role = '', exportResult = '') => {
                if (Object.keys(exportResult).length > 0) {
                    return false;
                }

                if (stateId === 4 || stateId === 5 || stateId === 1002 || stateId === 2002 || stateId === 3004 || stateId === 3005) {
                    return true;
                }

                if (role === 'manager' && (stateId === 3 || stateId === 3003)) {
                    return true;
                }

                return false;
            }
        ));
    },

    /**
     * Рассчитываем нужно ли показывать блок со статистикой
     * @param {Object} state
     */
    computeOrderStatisticState (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'showOrderStatistic'], monkey(
            ['account', 'orders', 'currentOrder', 'typeId'],
            ['account', 'orders', 'currentOrder', 'price', 'total', 'totalPrice'],
            (typeId = -1, totalPrice = -1) => {
                if (totalPrice <= 0) {
                    return false;
                }

                if (typeId === 2) {
                    return true;
                }

                return false;
            }
        ));
    },

    /**
     * Рассчитываем загружается ли статистика
     * @param {Object} state
     */
    computeOrderStatisticIsLoadingState (state) {
        state.set(['account', 'orders', 'computed', 'componentsState', 'isStatisticLoading'], monkey(
            ['order', 'originalParameters', 'statistic'],
            (statistic = {}) =>
            {
                if (Object.keys(statistic).length > 0) {
                    return false;
                }

                return true;
            }
        ));
    },

    computeIsDisabled (state) {
        state.set(['order', 'isDisabled'], monkey(
            ['account', 'orders', 'computed', 'currentOrder', 'isEditable'],
            (isEditable = false) => !isEditable
        ));
    },

    computeDatepickerIsDisabled (state) {
        state.set(['order', 'addParams', 'datepicker', 'ui', 'isDisabled'], monkey(
            ['order', 'isDisabled'],
            (isDisabled = true) => isDisabled
        ));
    },

    computeDatepicker2IsDisabled (state) {
        state.set(['order', 'addParams', 'datepicker2', 'ui', 'isDisabled'], monkey(
            ['order', 'isDisabled'],
            (isDisabled = true) => isDisabled
        ));
    }
};


function formatOptionTitle (user) {
    return `${formatter.shortName(user)} (${user.email})`;
}



// WEBPACK FOOTER //
// ./actions/computed/account/orders.js